import { register } from "@planningcenter/tapestry-render/registry"

import { PageHeader } from "./components/page-header/PageHeader"
import { Sidenav } from "./components/sidenav/Sidenav"
import { SidenavItem } from "./components/sidenav/SidenavItem"
import { SidenavSection } from "./components/sidenav/SidenavSection"

register("PageHeader", PageHeader)
register("Sidenav", Sidenav)
register("SidenavItem", SidenavItem)
register("SidenavSection", SidenavSection)
